<div class="overflow-menu" #overflowMenu>
  <ul class="main-nav-links">
    @for (menuItem of menuItems$ | async; track menuItem) {
      <li
        class="main-nav-links__item"
        [routerLinkActiveOptions]="{ exact: false }"
        [routerLink]="menuItem.path"
        [queryParams]="menuItem.queryParams"
        routerLinkActive="main-nav-links__item--active"
        @fadeAnimation
        tabindex="-1"
      >
        <a
          [routerLink]="menuItem.path"
          [queryParams]="menuItem.queryParams"
          tabindex="0"
          class="main-nav-links__link"
          data-track
        >
          {{ menuItem.title }}
        </a>
      </li>
    }
    @if ((dropdownItems$ | async)?.length) {
      <li class="main-nav-links__item main-nav-links__item--not-clickable" @fadeAnimation>
        <div class="overflow-more">
          <ng-template #openerTemplate>
            <button (click)="toggle()" (keydown.enter)="toggle()" class="overflow-menu">
              <span data-track>{{ !(menuItems$ | async)?.length ? 'Menu' : 'More' }}</span>
              <ftr-icon-legacy align="Bottom" icon="ChevronDown" />
            </button>
          </ng-template>
          <ftr-dropdown-menu-legacy
            [ariaLabel]="!(menuItems$ | async)?.length ? 'Menu' : 'More'"
            [menuItems]="(dropdownItems$ | async) ?? []"
            [openerTemplate]="openerTemplate"
            data-track-group="Main Menu Dropdown"
            [routerLinkActiveExact]="false"
          />
        </div>
      </li>
    }
  </ul>
</div>
